import { render, staticRenderFns } from "./MonoPhasePheDetails.vue?vue&type=template&id=54c3d242&"
import script from "./MonoPhasePheDetails.vue?vue&type=script&lang=js&"
export * from "./MonoPhasePheDetails.vue?vue&type=script&lang=js&"
import style0 from "./MonoPhasePheDetails.vue?vue&type=style&index=0&id=54c3d242&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports